import { clsx } from 'clsx';
import type { ReactNode } from 'react';

type CardProps = {
  children: ReactNode;
  className?: string;
  isLoading?: boolean;
};

export const Card = ({ children, className, isLoading }: CardProps) => {
  return (
    <div
      className={clsx(
        'overflow-hidden rounded-lg border border-border bg-surface p-4 md:p-6',
        isLoading && 'animate-pulse',
        className,
      )}
    >
      {children}
    </div>
  );
};
